import React, { createContext } from 'react'
import { useQuery } from '@apollo/client'
import { CONTACT_QUERY } from '../graphql/Contact'
import CentredLoader from '../components/CentredLoader'

export const ContactContext = createContext({} as any)

interface Iprops {
  contactId: number
  children: any
}
const ContactContextProvider = (props: Iprops) => {
  const { contactId } = props
  const { data, loading, refetch } = useQuery(CONTACT_QUERY, {
    variables: {
      id: contactId,
    },
    fetchPolicy: 'no-cache',
  })

  if (loading) {
    return <CentredLoader />
  }

  const contact = data.contact

  return (
    <ContactContext.Provider value={{ contact: contact }}>
      {props.children}
    </ContactContext.Provider>
  )
}

export default ContactContextProvider
